import React, { useEffect, useState,Fragment } from 'react'
import { Card, Col, Container, Form, Row, Button, Modal } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import { useDispatch, useSelector } from 'react-redux'
import {formato_rut} from '../../../../common/Formatos'
import {servicesActualizaDatosPersona} from '../../../../api/caso-general-client';
import { LoadingComponent } from 'recupero-comunes'
import {obtenerAntecedentesCaso} from '../../../../store/actions/caso-general-action'

const Conductor = ({permiteEditarPersona}) => {
  const dispatch = useDispatch()
  const data_datos_generales = useSelector((state) => state.casoGeneralReducer)
  const { cfg_form, antecedentesCasos, llaves } = data_datos_generales
  const [datosSiniestro, setDatosSiniestro] = useState({})

  const [loading, setLoading]=useState(false)
  
  const [showModal, setShowModal] = useState(false);
  const [persona, setPersona] = useState({});
  const [errorEmail, setErrorEmail] = useState('') 

  const validarEmail = (valor) => {
    const regex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,6}$/;
    return regex.test(valor);
  };

  const verEditarPersona = () => {
    console.log('Editar Conductor', antecedentesCasos)
    const datos = antecedentesCasos?.antecedentesCasos?.[0] || {};

    setPersona({
      rut: datos['RutConductor'] || '',
      nombre: datos['NombreConductor'] || '',
      telefono: datos['FonoConductor'] || '',
      email: datos['EmailConductor'] || '',
      idCaso: datos['IdCaso'] || '',
      idImplicado: 0,
      idInvolucrado: 211003 // Datos fijos para Conductor
    });
    setErrorEmail('')
    setShowModal(true);
  };
  const handleClose = () => setShowModal(false);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setPersona({ ...persona, [name]: value });
    
    if (name === 'email') {
      if (!value.trim()) {
        setErrorEmail('Debe ingresar un email.')
      } else if (!validarEmail(value)) {
        setErrorEmail('El email informado no tiene un formato válido.')
      } else {
        setErrorEmail('')
      }
    }
  };
  const handleActualizar = async () => {
    console.log('Persona actualizada:', persona);

    if (!persona.email || !persona.email.trim()) {
      setErrorEmail('Debe ingresar un email.')
      return
    }
    if (!validarEmail(persona.email)) {
      setErrorEmail('El email informado no tiene un formato válido.')
      return
    }

    setErrorEmail('')

    setLoading(true)
    const response = await servicesActualizaDatosPersona(persona);
    console.log("confirmarAsignacion.response: ", response);
    setLoading(false)
    
    if (response && response.code == 1) {
      setShowModal(false);

      let query = Buffer.from(
          JSON.stringify({
            idOrgCaso: llaves['idOrgCaso'],
            idCaso: llaves['idCaso']
          })
        ).toString('base64')
        dispatch(obtenerAntecedentesCaso(query)).then(()=>setLoading(false))
      
    } else {
      alert("Error al actualizar los datos del contratante.");
    }
  };

  return (
      <>
     <LoadingComponent show={loading}/>
    <Card className='mt-1 '>
      <Card.Header className='mt-0 mb-0 d-flex justify-content-between align-items-center' as='h6' style={{backgroundColor:"#D9EDF6", color:"#8578CD"}}>
        {cfg_form ? cfg_form.cfg_form['gestcasosrecup-tab-detcaso-title-cond'] : null}
        <Button 
          type='button'
          variant={`opciones me-md-2 ${permiteEditarPersona ? '' : 'btn-secondary'}`}
          size='sm'
          onClick={() => verEditarPersona(antecedentesCasos)}
          disabled={!permiteEditarPersona} 
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
              width='16'
            height='16'
            fill='currentColor'
            className='bi bi-pencil-square'
            viewBox='0 0 16 16'
          >
            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
            <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"/>
          </svg>
        </Button>
      </Card.Header>
      <Container>
        {cfg_form ? (
          <div>
            <Row>
              <Col>
                <Form.Label
                  className='mb-0'
                  style={{ fontWeight: 'bold', fontSize: '14px' }}
                >
                  {cfg_form.cfg_form['gestcasosrecup-tab-detcaso-rutcond']}
                </Form.Label>{' '}
                <br />
                <Form.Text className='mb-3'>
                  {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                    ? formato_rut(antecedentesCasos.antecedentesCasos[0]['RutConductor'])
                    : null}
                </Form.Text>
              </Col>
              <Col>
                <Form.Label
                  className=' mb-0'
                  style={{ fontWeight: 'bold', fontSize: '14px' }}
                >
                  {cfg_form.cfg_form['gestcasosrecup-tab-detcaso-nomcond']}
                </Form.Label>
                <br />
                <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                  {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                    ? antecedentesCasos.antecedentesCasos[0]['NombreConductor']
                    : null}
                </Form.Text>
              </Col>
              <Col>
                <Form.Label
                  className='mb-0'
                  style={{ fontWeight: 'bold', fontSize: '14px' }}
                >
                  {cfg_form.cfg_form['gestcasosrecup-tab-detcaso-dircond']}
                </Form.Label>
                <br />
                <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                  {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                    ? antecedentesCasos.antecedentesCasos[0]['DireccionConductor']
                    : null}
                </Form.Text>
              </Col>

              <Col>
                <Form.Label
                  className='mb-0'
                  style={{ fontWeight: 'bold', fontSize: '14px' }}
                >
                  {cfg_form.cfg_form['gestcasosrecup-tab-detcaso-emailcond']}
                </Form.Label>
                <br />
                <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                  {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                    ? antecedentesCasos.antecedentesCasos[0]['EmailConductor']
                    : null}
                </Form.Text>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Label
                  className='mt-3 mb-0'
                  style={{ fontWeight: 'bold', fontSize: '14px' }}
                >
                  {cfg_form.cfg_form['gestcasosrecup-tab-detcaso-fonocond']}
                </Form.Label>
                <br />
                <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                  {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                    ? antecedentesCasos.antecedentesCasos[0][
                        'FonoConductor'
                      ]
                    : null}
                </Form.Text>
              </Col>
              <Col>
                <Form.Label
                  className='mt-3 mb-0'
                  style={{ fontWeight: 'bold', fontSize: '14px' }}
                >
                  {cfg_form.cfg_form['gestcasosrecup-tab-detcaso-movilcond']}
                </Form.Label>
                <br />
                <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                  {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                    ? antecedentesCasos.antecedentesCasos[0][
                        'MovilConductor'
                      ]
                    : null}
                </Form.Text>
              </Col>

              <Col>
                <Form.Label
                  className='mt-3 mb-0'
                  style={{ fontWeight: 'bold', fontSize: '14px' }}
                >
                  {cfg_form.cfg_form['gestcasosrecup-tab-detcaso-comunacond']}
                </Form.Label>
                <br />
                <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                  {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                    ? antecedentesCasos.antecedentesCasos[0]['ComunaConductor']
                    : null}
                </Form.Text>
              </Col>
              <Col>
                <Form.Label
                  className='mt-3 mb-0'
                  style={{ fontWeight: 'bold', fontSize: '14px' }}
                >
                  {cfg_form.cfg_form['gestcasosrecup-tab-detcaso-ciudadcond']}
                </Form.Label>
                <br />
                <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                  {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                    ? antecedentesCasos.antecedentesCasos[0]['CiudadConductor']
                    : null}
                </Form.Text>
              </Col>
            </Row>
            
          </div>
        ) : null}
      </Container>
    </Card>

    <Modal size="xl" show={showModal} onHide={handleClose} centered>
        <Card>
            <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white' }}>
                Conductor
            </Card.Header>

            <Card.Body>
                <Row>
                  <Col>
                    <Form.Group className="mb-3" controlId="rut">
                      <Form.Label>NIT Informado</Form.Label>
                      <Form.Control
                        type="text"
                        name="rut"
                        value={persona.rut}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3" controlId="nombre">
                      <Form.Label>Nombre Informado</Form.Label>
                      <Form.Control
                        type="text"
                        name="nombre"
                        value={persona.nombre}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3" controlId="telefono">
                      <Form.Label>Teléfono/Móvil Informado</Form.Label>
                      <Form.Control
                        type="text"
                        name="telefono"
                        value={persona.telefono}
                        onChange={handleChange}
                      />
                    </Form.Group>
                    
                  </Col>
                  <Col>
                    <Form.Group className="mb-3" controlId="email">
                      <Form.Label>Email Informado</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        value={persona.email}
                        onChange={handleChange}
                        isInvalid={!!errorEmail}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {errorEmail}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
            </Card.Body>

            <Card.Footer style={{ display: 'flex', justifyContent: 'right' }}>
                <Button className='m-2 w-auto' variant="secondary" onClick={handleClose}> 
                  Cerrar
                </Button>
                <Button className='m-2 w-auto' variant='outline-info' onClick={handleActualizar}>
                  Actualizar
                </Button>
            </Card.Footer>
        </Card>        
      </Modal>
    </>
  )
}
export default Conductor